import { all } from 'redux-saga/effects';
import loginSaga from '../containers/LoginPage/saga';

export default function* rootSaga() {
  // Add your sagas inside the array in the all function e.g.:
  // all([yourSaga(), anotherSaga()])
  yield all([loginSaga()]);
}
